import React from 'react';

import { Button, IconButton } from '@wetransfer/transfer/oneui/react';
import './Banner.scss';

export interface Props {
  children: JSX.Element;
  isDismissible?: boolean;
  ctaLabel?: string;
  redirectionUrl?: string;
  dismissBanner: () => void;
  onClickCta: () => void;
  bannerRef?: any;
}

const Banner: React.FC<Props> = ({
  children,
  isDismissible = true,
  ctaLabel,
  redirectionUrl,
  dismissBanner,
  onClickCta,
  bannerRef,
}) => {
  return (
    <div
      className="Banner__wrapper"
      data-testid="banner-wrapper"
      ref={bannerRef}
    >
      <div className="Banner__content">{children}</div>

      <div className="Banner__buttons-wrapper">
        {redirectionUrl && ctaLabel && (
          <Button
            small={true}
            variant="secondary"
            stroke={true}
            as="a"
            href={redirectionUrl}
            className="Banner__button-cta"
            onClick={onClickCta}
          >
            <span>{ctaLabel}</span>
          </Button>
        )}
        {isDismissible && (
          <IconButton
            name="close--white-circle"
            size={16}
            className="Banner__button-icon"
            onClick={dismissBanner}
            data-testid="iconButton"
          />
        )}
      </div>
    </div>
  );
};

export default Banner;
